var chunkMapping = {
	"0": [
		4913
	],
	"3": [
		3994,
		4543
	],
	"97": [
		5040
	],
	"125": [
		5068
	],
	"126": [
		5069
	],
	"127": [
		5070
	],
	"130": [
		5073
	],
	"133": [
		5076
	],
	"134": [
		5077
	],
	"135": [
		5078
	],
	"136": [
		5079
	],
	"137": [
		5080
	],
	"138": [
		5081
	],
	"139": [
		5082
	],
	"140": [
		5083
	],
	"141": [
		5084
	],
	"142": [
		5085
	],
	"143": [
		5086
	],
	"144": [
		5087
	],
	"145": [
		5088
	],
	"146": [
		5089
	],
	"147": [
		5090
	],
	"148": [
		5091
	],
	"149": [
		5092
	],
	"150": [
		5093
	],
	"151": [
		5094
	]
};
var idToExternalAndNameMapping = {
	"3994": [
		"default",
		"./nuorder-components",
		3675
	],
	"4543": [
		"default",
		"./helios-components",
		3675
	],
	"4913": [
		"default",
		"./Containers",
		3584
	],
	"5040": [
		"default",
		"./OrderlessInvoices",
		3584
	],
	"5068": [
		"default",
		"./CheckoutV3",
		3584
	],
	"5069": [
		"default",
		"./HostWrapper",
		3584
	],
	"5070": [
		"default",
		"./CheckoutConfirmation",
		3584
	],
	"5073": [
		"default",
		"./AsyncEventTracker",
		3584
	],
	"5076": [
		"default",
		"./ContactCreditCards",
		3584
	],
	"5077": [
		"default",
		"./AuditDialog",
		3584
	],
	"5078": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3584
	],
	"5079": [
		"default",
		"./InvoiceDialog",
		3584
	],
	"5080": [
		"default",
		"./PaymentDueModal",
		3584
	],
	"5081": [
		"default",
		"./PaymentModal",
		3584
	],
	"5082": [
		"default",
		"./MobilePaymentsWrapper",
		3584
	],
	"5083": [
		"default",
		"./Challenge",
		3584
	],
	"5084": [
		"default",
		"./ShippingPromotionsListContainer",
		3584
	],
	"5085": [
		"default",
		"./Teams",
		3860
	],
	"5086": [
		"default",
		"./LightspeedReports",
		3584
	],
	"5087": [
		"default",
		"./ActivateLightspeedPayments",
		3584
	],
	"5088": [
		"default",
		"./MarketingLandingPage",
		3584
	],
	"5089": [
		"default",
		"./PaymentHistory",
		3584
	],
	"5090": [
		"default",
		"./ManagePaymentProcessing",
		3584
	],
	"5091": [
		"default",
		"./PaymentPreferences",
		3584
	],
	"5092": [
		"default",
		"./PaymentConfigurations",
		3584
	],
	"5093": [
		"default",
		"./ManagePaymentMethods",
		3584
	],
	"5094": [
		"default",
		"./PayPage",
		3584
	]
};
var idToRemoteMap = {
	"3994": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3675
		}
	],
	"4543": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3675
		}
	],
	"4913": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5040": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5068": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5069": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5070": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5073": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5076": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5077": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5078": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5079": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5080": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5081": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5082": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5083": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5084": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5085": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3860
		}
	],
	"5086": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5087": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5088": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5089": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5090": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5091": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5092": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5093": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5094": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}